import { render, staticRenderFns } from "./FarmingPractices.vue?vue&type=template&id=2ecd4511&scoped=true&"
import script from "./FarmingPractices.vue?vue&type=script&lang=js&"
export * from "./FarmingPractices.vue?vue&type=script&lang=js&"
import style1 from "./FarmingPractices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd4511",
  null
  
)

export default component.exports